import '../../styles/templates/pages/page.order-lookup.scss';

const OrderLookupLookup = function (event: Event) {
  event.preventDefault();

  const form = event.target as HTMLFormElement;
  form.classList.remove('error');

  const formData = new FormData(form);
  const order = formData.get('order');
  const email = formData.get('email');

  const url = `${form.action}${order}/${email}`;
  fetch(url)
    .then((res: Response) => {
      if (!res.ok) showError();
      else return res.json().then(handleResponse);
    })
    .catch(handleError);
};

const errorContainer = document.querySelector('.WizOrderForm .submit-area .error');
const wizOrderForm = document.querySelector('.WizOrderForm form');

const handleResponse = function (response?: { order_status_url?: string }) {
  if (response?.order_status_url) return (window.location.href = response?.order_status_url);
};

const handleError = function () {
  if (!errorContainer) return;
  errorContainer.innerHTML =
    "Sorry, we're having trouble contacting the server. Please try again later. Still having trouble? <a href='/pages/contact-us'>Contact us</a>.";
  wizOrderForm?.classList.add('error');
};

const showError = function () {
  if (!errorContainer) return;
  errorContainer.innerHTML =
    "<p>Order not found</p><span class='small-p'>Invalid combination. Please try a different email address or order confirmation #.</span>";
  wizOrderForm?.classList.add('error');
};

wizOrderForm?.addEventListener('submit', OrderLookupLookup);
